// extracted by mini-css-extract-plugin
export var active = "_ts-1";
export var circle = "_ts-0";
export var completed = "_ts-2";
export var connector = "_ts-4";
export var connectorCompleted = "_ts-7";
export var connectorSpacer = "_ts-5";
export var iconStrokeOverride = "_ts-8";
export var labelContainer = "_ts-6";
export var pending = "_ts-3";